import React, { ComponentType } from 'react';

import ErrorBoundary from '@blocks/error-boundary';

// HOC to wrap a component with an error boundary
const withErrorBoundary = <P extends object>(
  WrappedComponent: ComponentType<P>,
  fallback?: React.ReactNode,
) => {
  const forwardedPropTypes = WrappedComponent.propTypes;
  const ComponentWithErrorBoundary = (props: P) => (
    <ErrorBoundary fallback={fallback}>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );
  ComponentWithErrorBoundary.propTypes = forwardedPropTypes;
  return ComponentWithErrorBoundary;
};

export default withErrorBoundary;
